import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import ClearIcon from "@material-ui/icons/Clear";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { STButton, STText, STGrid } from "./styles";
import RestoreIcon from "@material-ui/icons/Restore";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { RouterStore } from "mobx-react-router";
import { STTypography } from "@src/Components/Common/EntityDelete/styles";

interface IProps {
  routing?: RouterStore;
}

@inject("routing")
@observer
export default class ReplaceWithPrimaryButton extends React.Component<IProps> {
  @observable isOpened: boolean = false;

  handleReplaceWithPrimary = () => {
    this.props.routing.history.push("/synchronization");
  };

  handleOpen = () => {
    this.isOpened = true;
  };

  handleClose = () => {
    this.isOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <STButton variant="contained" onClick={this.handleOpen}>
            <RestoreIcon />
            <STText>{Values.getLocalizationValue("replaceWithCopyOfPrimaryDb")}</STText>
          </STButton>
        </div>

        <SimpleModal width={500} isOpened={this.isOpened} onClose={this.handleClose}>
          <STGrid container direction="column" justify="space-between" alignItems="center">
            <STTypography>{Values.getLocalizationValue("areYouSureReplaceWithPrimary")}</STTypography>
            <Grid container justify="center" wrap="nowrap">
              <STButtonMargin onClick={this.handleReplaceWithPrimary} variant="contained" color="primary">
                <RestoreIcon />
              </STButtonMargin>
              <STButtonMargin onClick={this.handleClose} variant="contained">
                <ClearIcon />
              </STButtonMargin>
            </Grid>
          </STGrid>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
